// extracted by mini-css-extract-plugin
export default {"contactForm":"responsiveStyles_contactForm__fTx4-","contactInner":"responsiveStyles_contactInner__v0629"};